import React, { useState } from "react";

import Axios from "axios";
import { Box } from "@material-ui/core";

// material ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";

const SendTextMessageURL = "/api/sms/sendTextMessage";

export default function SendTextMessageModal(props) {
  const modalOpen = props.modalOpen;
  const setModalOpen = props.setModalOpen;
  const defaultReceiverInfo = {
    receiver: "",
    subject: "",
    message: ""
  };

  const [receiverInfo, setReceiverInfo] = useState(defaultReceiverInfo);
  function renderTextField(label, name, value, onChange) {
    return (<TextField
      fullWidth
      margin="dense"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      autoComplete="off"
      required
    />);
  }

  function onChangeReceiverInfo(e) {
    const { name, value } = e.target;
    setReceiverInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  var closeModal = () => {
    setReceiverInfo(defaultReceiverInfo);
    setModalOpen(false);
  };

  var SendTextMessage = () => {
    // alert("message sent "+receiverInfo.receiver+" "+receiverInfo.subject);
    if(window.confirm("確定寄送?")) {
      if (receiverInfo.receiver !== "" && receiverInfo.receiver !== undefined) {
        Axios.post(SendTextMessageURL, receiverInfo).then(function () {
          alert("寄送成功!");
        }).catch(function (err) {
          alert("寄送失敗!");
          console.log(err);
        });
      }
    }
    closeModal();
  };

  return (
    <Dialog
      open={modalOpen}
      maxWidth="lg"
      scroll="paper"
    >
      <DialogTitle>訊息達人寄送</DialogTitle>
      <DialogContent dividers>
        {renderTextField("收件手機號", "receiver", receiverInfo.receiver, onChangeReceiverInfo)}
        {renderTextField("標題", "subject", receiverInfo.subject, onChangeReceiverInfo)}
        <Box>
          <div>
          <textarea
            name="message"
            value={receiverInfo.message}       // Controlled input
            onChange={onChangeReceiverInfo}    // Event handler for changes
            placeholder="簡訊內容"           // Optional placeholder
            style={{
              marginTop: 20,
              width: "95%",
              height: 150,
              resize: "none",  // Optional: Prevents resizing of the textarea
              padding: "8px",  // Optional: Adds padding inside the textarea
              lineHeight: "1.5" // Optional: Increases line height for readability
            }}
          />
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={SendTextMessage} name="save" color="primary">
          儲存
        </Button>
        <Button onClick={closeModal} color="primary">
          取消
        </Button>
      </DialogActions>
    </Dialog>
  );
}